import AspectRatioBox from '../../common/component/AspectRatioBox';
import VideoAuto from '../../common/component/VideoAuto';
import {VideoSource} from '../../common/type';
import useIsLite from '../hook/useIsLite';

export interface MotionVideoProps {
  shouldReplay?: boolean;
  motionVideo?: VideoSource[];
  motionVideoPoster?: string;
  motionVideoPosterClassName?: string;
  motionVideoAspectRatio?: number;
  motionVideoAnimationMs?: number;
  motionVideoClassName?: string;
  title?: string;
  onEnded?: () => void;
}

export default function MotionVideo({
  shouldReplay = false,
  motionVideo,
  motionVideoPoster,
  motionVideoPosterClassName,
  motionVideoAspectRatio = 600 / 710,
  motionVideoAnimationMs = 400,
  motionVideoClassName,
  title,
  onEnded,
}: MotionVideoProps) {
  const isLite = useIsLite();
  const videoElement = (
    <VideoAuto
      thresholdShow={0.5}
      shouldReplay={shouldReplay}
      sources={motionVideo || []}
      poster={motionVideoPoster}
      posterType="image"
      posterClassName={motionVideoPosterClassName}
      title={title}
      className={cn(
        'absolute opacity-0 z-1',
        'animate-fadeIn',
        motionVideoClassName
      )}
      style={{
        animationDuration: `${motionVideoAnimationMs}ms`,
        animationDelay: '0.1s',
      }}
      onEnded={onEnded}
      isPosterOnly={isLite}
    />
  );

  if (motionVideoAspectRatio === 0) {
    return videoElement;
  }

  // TODO: 모션 영상이 왼쪽에서 나타났다가 중앙으로 오는 현상 간헐적으로 발생, 원인 찾으면 해결하자.
  // https://github.com/kakao-webtoon/web/pull/481#discussion_r598288943
  return (
    <AspectRatioBox
      aspectRatio={motionVideoAspectRatio}
      className="!absolute top-0"
    >
      {videoElement}
    </AspectRatioBox>
  );
}
